import styled from 'styled-components';

export const TextPreview = styled.div<{ style: any; }>`
  font-size: ${(props) => props.style.fontSize}px;
  font-family: ${(props) => props.style.fontFamily};
  color: ${(props) => props.style.color};
  text-align: ${(props) => props.style.textAlign};
  font-weight: ${(props) => props.style.fontWeight};
  line-height: 1.6;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
`;
